import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import routes from 'src/config/routes'
import { TEST_IDS } from 'src/constants/testIds'
import { FormattedPhoneNumber } from './FormattedPhoneNumber'
import useStyles from './styles'

interface Props {
  phone: string
}

export const OldPatientContent = ({ phone }: Props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <>
      <div className={classes.oldPatientTitle}>{t('old_patient_verification_code_page_desktop_headline')}</div>
      <div className={clsx(classes.info, classes.oldPatientInfo)}>
        <div className={classes.oldPatientInfoContent}>
          <span>{t('old_patient_verification_code_page_text_1')}</span>
          <br />
          <span className={classes.smsSentTo}>{t('old_patient_verification_code_page_text_2')}</span>
          <span className={classes.oldPatientPhoneNumber}>
            <FormattedPhoneNumber phone={phone} />
          </span>
          <br />
          <span>{t('old_patient_verification_code_page_change_phone_1')}</span>&nbsp;
          <span
            className={classes.notYourNumber}
            onClick={() => history.push(routes.patient)}
            data-test={TEST_IDS.changePhoneNumberLink}
          >
            {t('old_patient_verification_code_page_change_phone_2')}
          </span>
        </div>
      </div>
    </>
  )
}
